export const GoogleMapsApiKey = "AIzaSyAn4-6IDb-ae1ZelES7OWoxsImlJ_maR_w";
export const GoogleMapsInitLocation = {lat: 60.964116, lng: 9.319379};

export const PrimaryColor = "#3E474F";
export const SecondaryColor = "#1d7c14";
export const ErrorColor = "#ff5252";
export const WarningColor = "#ffc107";
export const UnimportantColor = "#9e9e9e";
export const InfoColor = "#2196F3";
export const SuperColorDark = "#9C27B0";
export const SuperColorLight = "#E1BEE7";
export const DefaultColor = "#0000008a";

export const SimStatus = {
    unknown: "unknown",
    pending: "pending",
    active: "active",
    paused: "paused",
    deleted: "deleted",
};

export const SimOperators = {
    telenor: "telenor",
    com4: "com4",
};

export const CanonicalHost = "anleggsterminal.no";


export const MaxGeofenceCountPerLocation = 5; // Also defined in Constants.scala
export const MaxLocationAreaCountPerLocation = 10; // Also defined in Constants.scala
export const MaxRegreminderLocationsPerUser = 4;

export const MaxRegReportFilterListParams = 15 // Also defined in Constants.scala

export const TerminalWarrantyYears = 2;

export const FamocoInTheField = "In the field" // Also defined in constants.go and Constants.scala

export const TheftAlarmMaxAndroidSdkVersion = 23; // We don't support theft alarm on devices > android 6